import { render, staticRenderFns } from "./Monetization.vue?vue&type=template&id=43c7556c&"
import script from "./Monetization.vue?vue&type=script&lang=js&"
export * from "./Monetization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c7556c')) {
      api.createRecord('43c7556c', component.options)
    } else {
      api.reload('43c7556c', component.options)
    }
    module.hot.accept("./Monetization.vue?vue&type=template&id=43c7556c&", function () {
      api.rerender('43c7556c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/dashboard/Monetization.vue"
export default component.exports